import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, initAnalytics } from "@/lib/analytics";

// Loads GA (Consent Mode v2) once on mount and sends a GA4 pageview on every
// route change. Renders nothing. Must live inside <BrowserRouter>.
// initAnalytics also sends the initial-load pageview; trackPageView dedupes.
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}
